




import { Component, Prop, Vue } from "vue-property-decorator";
import SellersCampaigns from "./SellersCampaigns.vue";

@Component({
  components: {
    SellersCampaigns,
  },
})
export default class SellesCampaignsReport extends Vue {}
